// filepath: /Users/paulojustinchan/Downloads/workspace/PriveMD/achieve-admin-frontend/src/components/DatePicker/DatePicker.js
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useTheme } from "@mui/material/styles";

const DatePickerComponent = ({
    isDisabled = false,
    defaultValue = null,
    format = "MM/DD/YYYY",
    maxDate = null,
    onChange = () => {},
}) => {
    const theme = useTheme();
    const [value, setValue] = useState(null);
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);

    useEffect(() => {
        setDisabled(isDisabled);
    }, [isDisabled]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                disabled={disabled}
                defaultValue={value}
                value={value}
                maxDate={maxDate}
                onChange={(newValue) => {
                    setValue(newValue);
                    onChange(newValue);
                }}
                format={format}
                slotProps={{
                    textField: {
                        size: "small",
                        sx: {
                            "& .MuiInputBase-root": {
                                height: 40,
                            },
                            "& .MuiInputBase-input": {
                                padding: "8px 14px",
                            },
                            "& .MuiSvgIcon-root": {
                                color: theme.palette.color.icon,
                            },
                        },
                    },
                }}
            />
        </LocalizationProvider>
    );
};

export default DatePickerComponent;
